<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading" class="mb-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="user.verificado"
            depressed
            class="mr-2"
            color="primary lighten-3"
            @click="$router.go(-1)"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-4"
            @click="salvar"
            :loading="loadingSalvar"
            :disabled="!form_valid"
            >Salvar</v-btn
          >
        </v-app-bar>
        <v-form ref="form" lazy-validation v-model="form_valid">
          <v-container fluid class="px-4">
            <v-row dense v-if="!user.verificado">
              <v-col cols="12">
                <v-alert type="error" prominent text>
                  Caro representante, precisamos concluir o seu cadastro
                  <br />Por favor, preencha os dados obrigatórios abaixo e
                  clique em SALVAR para poder prosseguir
                </v-alert>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col sm="6" cols="12">
                <v-text-field
                  ref="razao_social"
                  label="Razão Social"
                  :rules="rulesForm.razao_social"
                  v-model="representante.razao_social"
                  @keydown.native.enter="$refs.nome_fantasia.focus()"
                ></v-text-field>
              </v-col>
              <v-col sm="6" cols="12">
                <v-text-field
                  ref="nome_fantasia"
                  label="Nome Fantasia"
                  :rules="rulesForm.nome_fantasia"
                  v-model="representante.nome_fantasia"
                  @keydown.native.enter="$refs.cnpj.focus()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="6" cols="12">
                <v-text-field
                  ref="cnpj"
                  label="CNPJ"
                  :rules="rulesForm.cnpj"
                  v-model="representante.cnpj"
                  v-mask="'##.###.###/####-##'"
                  :return-masked-value="true"
                  @keydown.native.enter="$refs.ie.focus()"
                ></v-text-field>
              </v-col>
              <v-col sm="6" cols="12">
                <v-text-field
                  ref="ie"
                  label="Inscrição Estadual"
                  :rules="rulesForm.ie"
                  v-model="representante.ie"
                  @keydown.native.enter="$refs.logradouro.focus()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="7" cols="12">
                <v-text-field
                  ref="logradouro"
                  label="Logradouro"
                  :rules="rulesForm.logradouro"
                  v-model="representante.endereco.rua"
                  @keydown.native.enter="$refs.complemento.focus()"
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="12">
                <v-text-field
                  ref="complemento"
                  label="Complemento"
                  v-model="representante.endereco.complemento"
                  @keydown.native.enter="$refs.numero.focus()"
                ></v-text-field>
              </v-col>
              <v-col sm="2" cols="12">
                <v-text-field
                  ref="numero"
                  label="Número"
                  :rules="rulesForm.numero"
                  v-model="representante.endereco.numero"
                  @keydown.native.enter="$refs.bairro.focus()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="4" cols="12">
                <v-text-field
                  ref="bairro"
                  label="Bairro"
                  :rules="rulesForm.bairro"
                  v-model="representante.endereco.bairro"
                  @keydown.native.enter="$refs.estado.focus()"
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="12">
                <v-select
                  :items="estados"
                  ref="estado"
                  label="Estado"
                  :rules="rulesForm.estado"
                  v-model="representante.endereco.estado_id"
                  @change="onSelectEstado"
                  @keydown.native.enter="$refs.cidade.focus()"
                ></v-select>
              </v-col>
              <v-col sm="5" cols="12">
                <v-autocomplete
                  :items="cidades"
                  ref="cidade"
                  label="Cidade"
                  :rules="rulesForm.cidade"
                  v-model="representante.endereco.cidade_id"
                  :loading="loadingCidades"
                  @keydown.native.enter="$refs.cep.focus()"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="2" cols="12">
                <v-text-field
                  ref="cep"
                  label="CEP"
                  :rules="rulesForm.cep"
                  v-model="representante.endereco.cep"
                  v-mask="'#####-###'"
                  :return-masked-value="true"
                  @keydown.native.enter="$refs.telefone.focus()"
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="12">
                <v-text-field
                  ref="telefone"
                  label="Telefone"
                  :rules="rulesForm.telefone"
                  v-model="representante.endereco.telefone"
                  v-mask="'(##) ####-####'"
                  :return-masked-value="true"
                  @keydown.native.enter="$refs.celular.focus()"
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="12">
                <v-text-field
                  ref="celular"
                  label="Celular"
                  :rules="rulesForm.celular"
                  v-model="representante.endereco.celular"
                  v-mask="'(##) #####-####'"
                  :return-masked-value="true"
                  @keydown.native.enter="$refs.email.focus()"
                ></v-text-field>
              </v-col>
              <v-col sm="4" cols="12">
                <v-text-field
                  ref="email"
                  label="E-mail"
                  :rules="rulesForm.email"
                  v-model="representante.endereco.email"
                  @keydown.native.enter="$refs.banco.focus()"
                ></v-text-field>
              </v-col>
            </v-row>

            <h3>Dados Financeiros</h3>
            <v-row dense>
              <v-col cols="12" sm="3">
                <v-select
                  :items="bancos"
                  :rules="rulesForm.banco"
                  label="Banco"
                  v-model="representante.banco"
                  ref="banco"
                  @keydown.native.enter="$refs.conta.focus()"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  ref="conta"
                  label="Conta"
                  :rules="rulesForm.conta"
                  v-model="representante.conta"
                  @keydown.native.enter="$refs.agencia.focus()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  ref="agencia"
                  label="Agência"
                  :rules="rulesForm.agencia"
                  v-model="representante.agencia"
                  @keydown.native.enter="$refs.tipo_conta.focus()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select
                  :items="tipos_conta"
                  :rules="rulesForm.conta_tipo"
                  label="Tipo de conta"
                  v-model="representante.conta_tipo"
                  ref="tipo_conta"
                  @keydown.native.enter="salvar"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
      <!-- <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Responsável</v-toolbar-title>
        </v-app-bar>
        <v-form ref="formResponsavel" lazy-validation v-model="form_valid">
          <v-container fluid>
            <v-row dense>
              <v-flex sm8>
                <v-text-field ref="nome" label="Nome" :rules="rulesResponsavel.nome" v-model="responsavel.nome"></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-text-field
                  ref="cpf"
                  label="CPF"
                  :rules="rulesResponsavel.cpf"
                  v-model="responsavel.cpf"
                  mask="###.###.###-##"
                  :return-masked-value="true"
                ></v-text-field>
              </v-flex>
            </v-row>
            <v-row dense>
              <v-flex sm7>
                <v-text-field ref="logradouro" label="Logradouro" :rules="rulesResponsavel.logradouro" v-model="responsavel.endereco.rua"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field ref="complemento" label="Complemento" v-model="responsavel.endereco.complemento"></v-text-field>
              </v-flex>
              <v-flex sm2>
                <v-text-field ref="numero" label="Número" :rules="rulesResponsavel.numero" v-model="responsavel.endereco.numero"></v-text-field>
              </v-flex>
            </v-row>
            <v-row dense>
              <v-flex sm4>
                <v-text-field ref="bairro" label="Bairro" :rules="rulesResponsavel.bairro" v-model="responsavel.endereco.bairro"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-select
                  :items="estados"
                  ref="estado"
                  label="Estado"
                  :rules="rulesResponsavel.telefone"
                  v-model="responsavel.endereco.estado_id"
                  @change="onSelectEstadoResponsavel"
                ></v-select>
              </v-flex>
              <v-flex sm5
                ><v-autocomplete
                  :items="cidadesResponsavel"
                  ref="cidade"
                  label="Cidade"
                  :rules="rulesResponsavel.telefone"
                  v-model="responsavel.endereco.cidade_id"
                ></v-autocomplete>
              </v-flex>
            </v-row>
            <v-row dense>
              <v-flex sm2>
                <v-text-field
                  ref="cep"
                  label="CEP"
                  :rules="rulesResponsavel.cep"
                  v-model="responsavel.endereco.cep"
                  mask="#####-###"
                  :return-masked-value="true"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  ref="telefone"
                  label="Telefone"
                  :rules="rulesResponsavel.telefone"
                  v-model="responsavel.endereco.telefone"
                  mask="(##) ####-####"
                  :return-masked-value="true"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  ref="celular"
                  label="Celular"
                  :rules="rulesResponsavel.celular"
                  v-model="responsavel.endereco.celular"
                  mask="(##) #####-####"
                  :return-masked-value="true"
                ></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-text-field ref="email" label="E-mail" :rules="rulesResponsavel.email" v-model="responsavel.endereco.email"></v-text-field>
              </v-flex>
            </v-row>
          </v-container>
        </v-form>
      </v-card>-->

      <as-dialogo
        ref="dialogoInfoLogin"
        title="Informações para Login"
        max-width="600px"
        hideCloseButton
      >
        <p class="text--primary">
          Pronto, seu cadastro foi atualizado com sucesso!
        </p>
        <p class="text--primary">
          A partir de agora, quando for entrar no sistema, você deve utilizar o
          email que você acabou de informar.
        </p>
        <p class="text--primary">Login antigo: {{ login_antigo }}</p>
        <p class="text--primary">
          <b>Novo Login: {{ user.email }}</b>
        </p>
        <p class="text--primary">
          Sua senha não foi alterada, você deve continuar usando a mesma.
        </p>
        <div slot="botoes" class="pa-2">
          <v-btn depressed color="primary" @click="$router.push('/')">Ok</v-btn>
        </div>
      </as-dialogo>
    </v-container>
    <v-row v-show="loading" class="justify-center align-center mt-5">
      <v-progress-circular
        indeterminate
        size="50"
        width="3"
        color="primary"
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import Services from "@/services/services.js";
import ServiceRepresentantes from "@/services/representantes.js";
import validadores from "@/mixins/validadores-mixin";

export default {
  name: "MinhaContaRepresentante",
  mixins: [validadores],
  data() {
    return {
      loading: false,
      loadingSalvar: false,
      loadingCidades: false,
      loadingCidadesResponsavel: false,
      titulo: "Minha Conta",
      exibirPesquisa: false,
      pesquisa: "",
      form_valid: true,
      representante_id: JSON.parse(localStorage.getItem("user"))
        .representante_id,
      representante: {
        id: "",
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        endereco_id: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          cidade_id: "",
          estado: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
        banco: "",
        conta: "",
        agencia: "",
        conta_tipo: "",
      },
      responsavel: {
        id: "",
        cpf: "",
        nome: "",
        endereco_id: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          cidade_id: "",
          estado: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      },
      rulesForm: {
        razao_social: [(value) => !!value || "Campo obrigatório"],
        nome_fantasia: [(value) => !!value || "Campo obrigatório"],
        cnpj: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarCNPJ(value) || "CNPJ Inválido",
        ],
        ie: [(value) => !!value || "Campo obrigatório"],
        logradouro: [(value) => !!value || "Campo obrigatório"],
        numero: [(value) => !!value || "Campo obrigatório"],
        bairro: [(value) => !!value || "Campo obrigatório"],
        estado: [(value) => !!value || "Campo obrigatório"],
        cidade: [(value) => !!value || "Campo obrigatório"],
        cep: [(value) => !!value || "Campo obrigatório"],
        telefone: [(value) => !!value || "Campo obrigatório"],
        celular: [(value) => !!value || "Campo obrigatório"],
        email: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarEmail(value) || "E-mail inválido",
        ],
        banco: [(value) => !!value || "Campo obrigatório"],
        conta: [(value) => !!value || "Campo obrigatório"],
        agencia: [(value) => !!value || "Campo obrigatório"],
        conta_tipo: [(value) => !!value || "Campo obrigatório"],
      },
      rulesResponsavel: {
        nome: [(value) => !!value || "Campo obrigatório"],
        cpf: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarCPF(value) || "CPF Inválido",
        ],
        logradouro: [(value) => !!value || "Campo obrigatório"],
        bairro: [(value) => !!value || "Campo obrigatório"],
        estado: [(value) => !!value || "Campo obrigatório"],
        cidade: [(value) => !!value || "Campo obrigatório"],
        telefone: [(value) => !!value || "Campo obrigatório"],
        celular: [(value) => !!value || "Campo obrigatório"],
        email: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarEmail(value) || "E-mail inválido",
        ],
      },
      cidades: [],
      cidadesResponsavel: [],
      estados: Services.estados(),
      user: {},
      login_antigo: "",
      bancos: [
        "000 — Banco Bankpar S.A.",
        "001 — Banco do Brasil S.A.",
        "003 — Banco da Amazônia S.A.",
        "004 — Banco do Nordeste do Brasil S.A.",
        "007 — BNDES (Banco Nacional Do Desenvolvimento Social)",
        "010 — CREDICOAMO (Crédito Rural Cooperativa)",
        "011 — C.Suisse Hedging-Griffo Cv S.A (Credit Suisse)",
        "012 — Banco Standard de Investimentos S.A.",
        "014 — Natixis Brasil S.A. Banco Múltiplo",
        "015 — UBS Brasil Cctvm S.A.",
        "016 — Ccm Desp Trâns SC E RS",
        "017 — Bny Mellon Banco S.A.",
        "018 — Banco Tricury S.A.",
        "019 — Banco Azteca do Brasil S.A.",
        "021 — BANESTES S.A. (Banco do Estado do Espírito Santo)",
        "024 — Banco de Pernambuco S.A. (BANDEPE)",
        "025 — Banco Alfa S.A.",
        "029 — Banco Banerj S.A.",
        "031 — Banco Beg S.A.",
        "033 — Banco Santander (Brasil) S.A.",
        "036 — Banco Bradesco BBI S.A.",
        "037 — Banco do Estado do Pará S.A.",
        "039 — Banco do Estado do Piauí S.A. (BEP)",
        "040 — Banco Cargill S.A.",
        "041 — Banco do Estado do Rio Grande do Sul S.A.",
        "044 — Banco BVA S.A.",
        "045 — Banco Opportunity S.A.",
        "047 — Banco do Estado de Sergipe S.A.",
        "060 — Confidence Cc S.A.",
        "062 — Hipercard Banco Múltiplo S.A.",
        "063 — Banco Ibi S.A. Banco Múltiplo",
        "064 — Goldman Sachs do Brasil Banco Múltiplo S.A.",
        "065 — Banco Bracce S.A.",
        "066 — Banco Morgan Stanley S.A.",
        "069 — BPN Brasil Banco Múltiplo S.A.",
        "070 — BRB (Banco de Brasília S.A.)",
        "072 — Banco Rural Mais S.A.",
        "073 — BB Banco Popular do Brasil S.A.",
        "074 — Banco J. Safra S.A.",
        "075 — Banco CR2 S.A.  ",
        "076 — Banco KDB S.A.",
        "077 — Banco Intermedium S.A.",
        "078 — BES Investimento do Brasil S.A. (Banco de Investimento)",
        "079 — Banco Original do Agronegócio S.A.",
        "080 — B&T Cc Ltda",
        "081 — Banco Seguro S.A.",
        "081-7 — Concórdia Banco S.A.",
        "082 — Banco Topázio S.A.",
        "083 — Banco da China Brasil S.A.",
        "084 — Unicred Norte do Paraná",
        "085 — Cooperativa Central de Crédito Urbano (CECRED)",
        "086 — OBOE Crédito Financiamento e Investimento S.A.",
        "087 — Cooperativa Unicred Central Santa Catarina",
        "088 — Banco Randon S.A.",
        "089 — Cooperativa de Crédito Rural da Região de Mogiana",
        "091 — Unicred Central do Rio Grande do Sul",
        "092 — Brickell S.A. Crédito, financiamento e Investimento",
        "093 — PóloCred Scmepp Ltda",
        "094 — Banco Finaxis",
        "094-2 — Banco Petra S.A.",
        "095 — Banco Confidence de Câmbio S.A.",
        "096 — Banco BM&F de Serviços de Liquidação e Custódia S.A",
        "097 — Cooperativa Central de Crédito Noroeste Brasileiro Ltda.",
        "098 — Credialiança Ccr",
        "098-1 — Credicorol Cooperativa de Crédito Rural",
        "099 — Uniprime Central Ccc Ltda",
        "099-X — Cooperativa Central de Economia e Credito Mutuo das Unicreds",
        "100 — Planner Corretora de Valores S.A.",
        "101 — Renascença Dtvm Ltda",
        "102 — XP Investimentos S.A.",
        "104 — Caixa Econômica Federal",
        "105 — Lecca Cfi S.A.",
        "107 — Banco BBM S.A.",
        "108 — Portocred S.A.",
        "111 — Banco Oliveira Trust Dtvm S.A.",
        "113 — Magliano S.A.",
        "114 — Central Cooperativa de Crédito no Estado do Espírito Santo",
        "117 — Advanced Cc Ltda",
        "118 — Standard Chartered Bi S.A.",
        "119 — Banco Western Union do Brasil S.A.",
        "120 — Banco Rodobens S.A.",
        "121 — Banco Agibank S.A.",
        "122 — Banco Bradesco BERJ S.A.",
        "124 — Banco Woori Bank Do Brasil S.A.",
        "125 — Brasil Plural S.A Banco",
        "126 — BR Partners Banco de Investimento S.A.",
        "127 — Codepe Cvc S.A.",
        "128 — Ms Bank S.A. Banco De Câmbio",
        "129 — UBS Brasil Bi S.A.",
        "130 — Caruana Scfi",
        "131 — Tullett Prebon Brasil Cvc Ltda",
        "132 — ICBC do Brasil Bm S.A.",
        "133 — Cresol Confederação",
        "134 — BGC Liquidez Dtvm Ltda",
        "136 — Unicred Cooperativa LTDA",
        "138 — Get Money Cc Ltda",
        "139 — Intesa Sanpaolo Brasil S.A.",
        "140 — Easynvest (Título Cv S.A.)",
        "142 — Broker Brasil Cc Ltda",
        "143 — Treviso Cc S.A.",
        "144 — Bexs Banco De Cambio S.A.",
        "145 — Levycam Ccv Ltda",
        "146 — Guitta Cc Ltda",
        "149 — Facta S.A. Cfi",
        "157 — Icap Do Brasil Ctvm Ltda",
        "159 — Casa do Crédito S.A.",
        "163 — Commerzbank Brasil S.A Banco Múltiplo",
        "168 — HSBC Finance (Brasil) S.A. (Banco Múltiplo)",
        "169 — Banco Olé Bonsucesso Consignado S.A.",
        "172 — Albatross Ccv S.A.",
        "173 — BRL Trust Dtvm Sa",
        "174 — Pernambucanas Financ S.A.",
        "177 — Guide Investimentos S.A. Corretora de Valores  ",
        "180 — Cm Capital Markets Cctvm Ltda",
        "182 — Dacasa Financeira S/A",
        "183 — Socred S.A.",
        "184 — Banco Itaú BBA S.A.",
        "188 — Ativa S.A Investimentos",
        "189 — HS Financeira",
        "190 — Servicoop",
        "191 — Nova Futura Ctvm Ltda",
        "194 — Parmetal Dtvm Ltda",
        "196 — Banco Fair Cc S.A.",
        "197 — Stone Pagamentos S.A.",
        "204 — Banco Bradesco Cartões S.A.",
        "208 — Banco BTG Pactual S.A.",
        "212 — Banco Matone S.A.",
        "213 — Banco Arbi S.A.",
        "214 — Banco Dibens S.A.",
        "215 — Banco Comercial e de Investimento Sudameris S.A.",
        "217 — Banco John Deere S.A.",
        "218 — Banco Bs2 S.A.",
        "222 — Banco Credit Agricole Brasil S.A.",
        "224 — Banco Fibra S.A.",
        "225 — Banco Brascan S.A.",
        "229 — Banco Cruzeiro do Sul S.A.",
        "230 — Unicard Banco Múltiplo S.A.",
        "233 — Banco GE Capital S.A.",
        "237 — Banco Bradesco S.A.",
        "241 — Banco Clássico S.A.",
        "243 — Banco Máxima S.A.",
        "246 — Banco ABC Brasil S.A.",
        "248 — Banco Boavista Interatlântico S.A.",
        "249 — Banco Investcred Unibanco S.A.",
        "250 — Banco Schahin S.A.",
        "253 — Bexs Cc S.A.",
        "254 — Paraná Banco S.A.",
        "259 — MONEYCORP Banco de Cämbio S.A.",
        "260 — Nu Pagamentos S.A (Nubank)",
        "263 — Banco Cacique S.A.",
        "265 — Banco Fator S.A.",
        "266 — Banco Cédula S.A.",
        "268 — Barigui Companhia Hipotecária",
        "269 — Hsbc Banco De Investimento",
        "270 — Sagitur Cc Ltda",
        "271 — Ib Cctvm Ltda",
        "272 — AGK Corretora de Câmbio S.A.",
        "273 — Ccr De São Miguel Do Oeste",
        "274 — MONEY PLUS Sociedade de Crédito",
        "276 — Senff S.A.",
        "278 — Genial Investimentos Cvm S.A.",
        "279 — Ccr De Primavera Do Leste",
        "280 — Avista S.A.",
        "281 — Cooperativa de Crédito Rural Coopavel",
        "283 — RB Capital Investimentos Dtvm Ltda",
        "285 — Frente Cc Ltda",
        "286 — Cooperativa de Crédito Rural de De Ouro",
        "288 — Carol Dtvm Ltda",
        "289 — DECYSEO Corretora de Câmbio LTDA.",
        "290 — PagSeguro Internet S.A.",
        "292 — BS2 Distribuidora De Títulos E Investimentos",
        "293 — Lastro Rdv Dtvm Ltda",
        "296 — VISION S.A. Corretora de Câmbio",
        "298 — Vip’s Cc Ltda",
        "299 — SOROCRED Crédito, Financiamento E Investimento S.A.",
        "300 — Banco de La Nacion Argentina",
        "301 — BPP Instituição De Pagamentos S.A.",
        "306 — PORTOPAR Distribuidora de Títulos e Valores Mobiliários",
        "307 — Terra Investimentos Distribuidora de Títulos e Valores Mobiliários",
        "309 — CAMBIONET Corretora de Câmbio LTDA.",
        "310 — VORTX Dtvm Ltda",
        "313 — AMAZÔNIA Corretora de Câmbio LTDA.",
        "315 — PI Distribuidora de Títulos e Valores Mobiliários S.A.",
        "318 — Banco BMG S.A.",
        "319 — OM Distribuidora de Títulos e Valores Mobiliários LTDA",
        "320 — Banco Industrial e Comercial S.A.",
        "322 — Cooperativa de Crédito Rural de Abelardo Luz (Sulcredi/Crediluz)",
        "323 — Mercado Pago (Conta do Mercado Livre)",
        "324 — CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A.",
        "325 — Órama Distribuidora de Títulos e Valores Mobiliários S.A.",
        "326 — PARATI (Crédito, Financiamento e investimento S.A.)",
        "329 — QI Sociedade de Crédito Direto S.A.",
        "330 — Banco Bari de Investimentos e Financiamentos S.A.",
        "331 — Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.",
        "332 — Acesso Soluções de Pagamento S.A.",
        "335 — Banco Digio S.A.",
        "336 — Banco C6 S.A (C6 Bank)",
        "340 — Super Pagamentos S/A (Superdital)",
        "341 — Itaú Unibanco S.A.",
        "342 — Creditas Sociedade de Crédito Direto S.A.",
        "343 — FFA Sociedade de crédito ao Microempreendedor",
        "348 — Banco XP S/A",
        "349 — AL5 S.A. Crédito, Financiamento e Investimento",
        "350 — Cooperativa de Crédito Rural de Pequenos Agricultores  ",
        "352 — TORO Corretora de Títulos e Valores Mobiliários LTDA",
        "354 — NECTON Investimentos S.A.",
        "355 — ÓTIMO Sociedade de Crédito Direto S.A.",
        "356 — Banco Real S.A.",
        "359 — ZEMA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A",
        "360 — TRINUS Capital Distribuidora De Títulos E Valores Mobiliários S.A.",
        "362 — CIELO S.A.",
        "363 — SOCOPA Sociedade Corretora Paulista S.A.",
        "364 — GERENCIANET S.A.",
        "365 — SOLIDUS S.A. Corretora de Câmbio e Valores Mobiliários",
        "366 — Banco Société Générale Brasil S.A.",
        "367 — VITREO Distribuidora de Títulos e Valores Mobiliários",
        "368 — Banco CSF S.A.",
        "370 — Banco WestLB do Brasil S.A.",
        "371 — WARREN Corretora de Valores Mobiliários e Câmbio LTDA.",
        "373 — UP.P Sociedade de Empréstimo entre pessoas S.A.",
        "374 — REALIZE Crédito, Financiamento e Investimento S.A.",
        "376 — Banco J. P. Morgan S.A.",
        "377 — MS Sociedade de Crédito ao Microempreendedor e a empresa",
        "378 — BBC LEASING S.A. (Arrendamento Mercantil)",
        "379 — COOPERFORTE  ",
        "380 — PICPAY Serviços S.A.",
        "381 — BANCO Mercedes-Benz DO BRASIL S.A.",
        "382 — FIDÚCIA Sociedade de Crédito ao Microempreendedor",
        "383 — BOLETOBANCÁRIO.COM Tecnologia de Pagamentos LTDA.",
        "384 — Global Finanças",
        "387 — Banco Toyota do Brasil S.A.",
        "389 — Banco Mercantil do Brasil S.A.",
        "390 — BANCO GM S.A.",
        "391 — Cooperativa de Crédito Rural de IBIAM (SULCREDI/IBIAM)",
        "393 — Banco Volkswagen S.A.",
        "394 — Banco Bradesco Financiamentos S.A.",
        "396 — HUB Pagamentos S.A.",
        "397 — LISTO Sociedade de Crédito Direto S.A.",
        "399 — HSBC Bank Brasil S.A. (Banco Múltiplo)",
        "403 — CORA Sociedade de Crédito Direto S.A.",
        "404 — SUMUP Sociedade de Crédito Direto S.A.",
        "408 — BÔNUSCRED Sociedade de Crédito Direto S.A.",
        "409 — Unibanco (União de Bancos Brasileiros S.A.)",
        "412 — Banco Capital S.A.",
        "422 — Banco Safra S.A.",
        "453 — Banco Rural S.A.",
        "456 — Banco de Tokyo-Mitsubishi UFJ Brasil S.A.",
        "464 — Banco Sumitomo Mitsui Brasileiro S.A.",
        "473 — Banco Caixa Geral (Brasil S.A.)",
        "477 — Citibank N.A.",
        "479 — Banco ItaúBank S.A",
        "487 — Deutsche Bank S.A. (Banco Alemão)",
        "488 — JPMorgan Chase Bank",
        "492 — ING Bank N.V.",
        "494 — Banco de La Republica Oriental del Uruguay",
        "495 — Banco de La Provincia de Buenos Aires",
        "505 — Banco Credit Suisse (Brasil) S.A.",
        "545 — Senso Ccvm S.A.",
        "600 — Banco Luso Brasileiro S.A.",
        "604 — Banco Industrial do Brasil S.A.",
        "610 — Banco VR S.A.",
        "611 — Banco Paulista S.A.",
        "612 — Banco Guanabara S.A.",
        "613 — Banco Pecúnia S.A.",
        "623 — Banco Panamericano S.A.",
        "626 — Banco Ficsa S.A.",
        "630 — Banco Intercap S.A.",
        "633 — Banco Rendimento S.A.",
        "634 — Banco Triângulo S.A.",
        "637 — Banco Sofisa S.A.",
        "638 — Banco Prosper S.A.",
        "641 — Banco Alvorada S.A.",
        "643 — Banco Pine S.A.",
        "652 — Itaú Unibanco Holding S.A.",
        "653 — Banco Indusval S.A.",
        "654 — Banco A.J.Renner S.A.",
        "655 — Banco Votorantim S.A.",
        "707 — Banco Daycoval S.A.",
        "712 — Banco Ourinvest S.A.",
        "719 — Banif-Banco Internacional do Funchal (Brasil)S.A.",
        "721 — Banco Credibel S.A.",
        "724 — Banco Porto Seguro S.A.",
        "734 — Banco Gerdau S.A.",
        "735 — Banco Pottencial S.A.",
        "738 — Banco Morada S.A.",
        "739 — Banco BGN S.A.",
        "740 — Banco Barclays S.A.",
        "741 — Banco Ribeirão Preto S.A.",
        "743 — Banco Semear S.A.",
        "744 — BankBoston N.A.",
        "745 — Banco Citibank S.A.",
        "746 — Banco Modal S.A.",
        "747 — Banco Rabobank International Brasil S.A.",
        "748 — Banco Cooperativo Sicredi S.A.",
        "749 — Banco Simples S.A.",
        "751 — Dresdner Bank Brasil S.A. (Banco Múltiplo)",
        "752 — Banco BNP Paribas Brasil S.A.",
        "753 — NBC Bank Brasil S.A. (Banco Múltiplo)",
        "754 — Banco Sistema S.A.",
        "755 — Bank of America Merrill Lynch Banco Múltiplo S.A.",
        "756 — Banco Cooperativo do Brasil S.A. – BANCOOB",
        "757 — Banco KEB do Brasil S.A.",
        "M03 — Banco Fiat S.A.",
        "M06 — Banco de Lage Landen Brasil S.A.",
        "M07 — Banco GMAC S.A.",
        "M08 — Banco Citicard S.A.",
        "M09 — Banco Itaucred Financiamentos S.A.",
        "M10 — Banco Moneo S.A.",
        "M11 — Banco IBM S.A.",
        "M12 — Banco Maxinvest S.A.",
        "M13 — Banco Tricury S.A.",
        "M14 — Banco Volkswagen S.A.",
        "M15 — Banco BRJ S.A.",
        "M16 — Banco Rodobens S.A.",
        "M17 — Banco Ourinvest S.A.",
        "M18 — Banco Ford S.A.",
        "M19 — Banco CNH Capital S.A.",
        "M20 — Banco Toyota do Brasil S.A.",
        "M21 — Banco Daimlerchrysler S.A.",
        "M22 — Banco Honda S.A.",
        "M23 — Banco Volvo (Brasil) S.A.",
        "M24 — Banco PSA Finance Brasil S.A.",
      ],
      tipos_conta: ["Conta Corrente", "Conta Poupança"],
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.verificado == 0) {
      this.representante.endereco.email = this.user.email;
    }
    this.listar();
  },
  methods: {
    async listar() {
      try {
        this.loading = true;

        let response = await ServiceRepresentantes.index(
          this.$auth.user.representante_id
        );
        this.representante = response.data.representante;
        // this.responsavel = response.data.responsavel;

        await this.onSelectEstado();
        await this.onSelectEstadoResponsavel();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async onSelectEstado() {
      try {
        this.loadingCidades = true;
        let response = await Services.cidades(
          this.representante.endereco.estado_id
        );
        this.cidades = response.data.cidades;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingCidades = false;
      }
    },
    async onSelectEstadoResponsavel() {
      try {
        this.loadingCidadesResponsavel = true;
        let response = await Services.cidades(
          this.responsavel.endereco.estado_id
        );
        this.cidadesResponsavel = response.data.cidades;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingCidadesResponsavel = false;
      }
    },
    async salvar() {
      // if (this.$refs.form.validate() && this.$refs.formResponsavel.validate()) {
      if (this.$refs.form.validate()) {
        try {
          this.loadingSalvar = true;
          let post = {
            representante: this.representante,
            // responsavel: this.responsavel,
          };
          let response = await ServiceRepresentantes.salvarConfig(post);
          this.$eventbus.notificar("Dados da conta salvos com sucesso.");

          if (this.user.verificado) {
            this.$router.push("/");
          } else {
            this.login_antigo = this.user.email;
            this.user.email = this.representante.endereco.email;
            this.user.verificado = 1;
            localStorage.setItem("user", JSON.stringify(response.data.user));
            this.$refs.dialogoInfoLogin.abrir();
          }
        } catch (error) {
          console.log(error);
          this.$eventbus.erro(error.response.data.message);
        } finally {
          this.loadingSalvar = false;
        }
      }
    },
  },
};
</script>
